import React from 'react'
import logo from '../images/logo.png'

const Header = () => {
  return (
    <div className='pb-4 mt-5'>
      <img className='img-fluid' src={logo}></img>
   </div>
  )
}

export default Header
